<div #requiredWrapper class="form-control required-wrapper">
  <ng-content></ng-content>
</div>
